import { Button, List, ListContent, ListDescription, ListHeader, ListItem, Label } from "semantic-ui-react";
import { PermitTypeOrgRole } from "../models/PermitTypeOrgRole";

interface Props {
  permitTypeRoles?: PermitTypeOrgRole[];
  onSettings: (permitTypeOrgRole: PermitTypeOrgRole) => void;
  onRemove: (permitTypeOrgRole: PermitTypeOrgRole) => void;
}

const PermitTypeRolesGrid = ({ permitTypeRoles, onSettings, onRemove }: Props) => {
  const renderRoleItem = (role: PermitTypeOrgRole) => {
    return (
      <ListItem key={role.id}>
        <ListContent>
          <ListHeader>
            {role.orgRole.displayName}
            {role.settings === null && (
              <Label size="mini" basic style={{ marginLeft: "8px" }}>
                default
              </Label>
            )}
          </ListHeader>
          <ListDescription>
            <Button basic circular style={{ padding: "5px", boxShadow: "0px 0px" }} onClick={() => onSettings(role)}>
              Settings
            </Button>{" "}
            /{" "}
            <Button basic circular style={{ padding: "5px", boxShadow: "0px 0px" }} onClick={() => onRemove(role)}>
              Remove
            </Button>
          </ListDescription>
        </ListContent>
      </ListItem>
    );
  };

  return (
    <List divided relaxed>
      {permitTypeRoles?.map(renderRoleItem)}
    </List>
  );
};

export default PermitTypeRolesGrid;

